/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { PaginatedServiceOrderListListResponse } from '../types/PaginatedServiceOrderListList';

import type { UseResource } from '../../hooks/useResource';
import { useResource } from '../../hooks/useResource';

export type ServiceOrdersListRequest = {} | null | undefined;
export type ServiceOrdersListResponse = PaginatedServiceOrderListListResponse;

export type ServiceOrdersListQuery = {
  /**
   * ```yaml
   * in: query
   * name: data_order
   * schema:
   *   type: integer
   * ```
   */
  data_order?: number;

  /**
   * ```yaml
   * in: query
   * name: name__icontains
   * schema:
   *   type: string
   * ```
   */
  name__icontains?: string;

  /**
   * ```yaml
   * name: page
   * required: false
   * in: query
   * description: A page number within the paginated result set.
   * schema:
   *   type: integer
   * ```
   */
  page?: number;

  /**
   * ```yaml
   * name: page_size
   * required: false
   * in: query
   * description: Number of results to return per page.
   * schema:
   *   type: integer
   * ```
   */
  page_size?: number;

  /**
   * ```yaml
   * in: query
   * name: price_list_item
   * schema:
   *   type: integer
   * ```
   */
  price_list_item?: number;

  /**
   * ```yaml
   * name: search
   * required: false
   * in: query
   * description: A search term.
   * schema:
   *   type: string
   * ```
   */
  search?: string;

  /**
   * ```yaml
   * in: query
   * name: state
   * schema:
   *   type: string
   *   enum:
   *     - CREATED
   *     - DRAFT
   *     - PAID
   * description: |-
   *   * `DRAFT` - Draft
   *   * `CREATED` - Created
   *   * `PAID` - Paid
   * ```
   */
  state?: 'CREATED' | 'DRAFT' | 'PAID';

  /**
   * ```yaml
   * in: query
   * name: state__in
   * schema:
   *   type: array
   *   items:
   *     type: string
   *     enum:
   *       - CREATED
   *       - DRAFT
   *       - PAID
   * description: |-
   *   * `DRAFT` - Draft
   *   * `CREATED` - Created
   *   * `PAID` - Paid
   * explode: true
   * style: form
   * ```
   */
  state__in?: ('CREATED' | 'DRAFT' | 'PAID')[];
};

/**
 * GET /dmx-server/service_orders/
 *
 * ```yaml
 * operationId: service_orders_list
 * tags:
 *   - service_orders
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/PaginatedServiceOrderListList'
 *     description: ''
 * ```
 */
export const serviceOrdersListOperation = (rest?: ServiceOrdersListQuery | null) =>
  ({
    method: 'GET',
    path: `/dmx-server/service_orders/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'GET';
    path: string & { _templateUrl: '/dmx-server/service_orders/' };
  };

/**
 * GET /dmx-server/service_orders/
 *
 * ```yaml
 * operationId: service_orders_list
 * tags:
 *   - service_orders
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/PaginatedServiceOrderListList'
 *     description: ''
 * ```
 */
export const serviceOrdersList = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query?: ServiceOrdersListQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<PaginatedServiceOrderListListResponse>> => {
  const operation = serviceOrdersListOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'GET',
    request,
    onUploadProgress,
    cancelToken,
  );
};

/**
 * GET /dmx-server/service_orders/
 */
export const useServiceOrdersListResource = (
  query: ServiceOrdersListQuery | null,
  useCached?: boolean,
): UseResource<ServiceOrdersListResponse> => {
  return useResource<ServiceOrdersListResponse>({
    path: query === null ? null : serviceOrdersListOperation(query).path,
    apiUrl: globalThis.DMX_CONFIG.server,
    useCached,
  });
};
